import { reducers } from 'redux/core'
import request from 'sb-request'


const getLeaderBoardData = (filterValue = 'current') =>
  request.get(`rest/stats/referral-leaderboard/${filterValue}`)
    .then((data) => reducers.view.invitePage.setLeaderBoardData(data))


export default {
  getLeaderBoardData,
}
